<div [class]="'vehicle-info-container' + (formClass ? ' ' + formClass : '')">
  @if (npId) {
    <div>
      <div class="vehicle-class-container">
        @if (vehicleDetail && !isLoading) {
          <div class="row mx-0 pl-2">
            <div class="mt-1">
              <span class="np">{{ vehicleDetail.numberPlate }}</span>
              <br>
                <span class="np-country">  {{ vehicleDetail.country }}</span>
              </div>
            </div>
          }
          @if (isLoading) {
            <div>
              <span class="loading"><span class="dot">.</span><span class="dot">.</span><span class="dot">.</span></span>
            </div>
          }
          @if (vehicleDetail && !isLoading) {
            <div class="mb-1 pl-2">
              <div class="">
                <span class="nav-link reference" (click)="openGoogle(googleLookup)">{{ vehicleDetail.brand }} - {{ vehicleDetail.model }}</span>
                @if (vehicleDetail.gvw) {
                  <span class="mr-2">{{ vehicleDetail.gvw?.toString() }} kg</span>
                }
                <span class="mr-2">{{ vehicleDetail.category }}</span>
                <span class="mr-1">{{ vehicleDetail.color }}</span>
                <span class="">{{ vehicleDetail.registrationDate | date: 'yyyy' }}</span>
              </div>
              <div class="ml-auto">
                @if (!isLoading && vehicleDetail.category) {
                  <img class="vehicle-icon" src="/assets/img/{{ vehicleDetail.category }}.png" />
                }
              </div>
            </div>
          }
          @if (!vehicleDetail && !isLoading) {
            <div>
              <p class="ml-2">{{ 'BO_VEHICLE_NOT_FOUND' | translate }}</p>
            </div>
          }
        </div>
        <div [class]="'card-plain mb-1' + (cardClass ? ' ' + cardClass : '')">
          @if (enableCorrections) {
            <span class="ml-3 text-success anpr-add" (click)="addAnprRecord()">+ add</span>
          }
          <data-list class="mb-0 vehicle-info-table" [noResult]="''" [cellProps]="anprTableProps" [listItems]="currentAnprRecords">
          </data-list>
          @if (otherAnprRecords) {
            <data-list [noResult]="''" class="mb-0 vehicle-info-table other-anpr" [cellProps]="anprTableProps" [listItems]="otherAnprRecords">
            </data-list>
          }
        </div>
        @if (showClaimCount && additionalInfo) {
          <div [class]="'card-plain mb-0 vehicle-duplicates-container' + (cardClass ? ' ' + cardClass : '')">
            <data-list class="fullwidth-table fullwidth-table-slim mb-0 vehicle-info-table" [noResult]="''" [cellProps]="additionalInfoTableProps"
              [listItems]="additionalInfo">
            </data-list>
          </div>
        }
      </div>
    }
  </div>